import ConnectPrintModal from './ConnectPrintModal.component';
import FormsModal from './FormsModal.component';
import LabelPreview from './LabelPreview.component';
import PdfPreviewModal from './PdfPreviewModal.component';
import PrintEngine from './PrintEngine.component';
import PrintModal from './PrintModal.component';
import ThinClientPrintModal from './ThinClientPrintModal.component';

export default {
	LabelPreview,
	PrintEngine,
	PrintModal,
	ConnectPrintModal,
	ThinClientPrintModal,
	PdfPreviewModal,
	FormsModal,
};
